import React, { useEffect, useState } from 'react'

const injectKeyframes = () => {
  if (typeof document === 'undefined') return

  const id = 'snowfall-keyframes'

  if (document.getElementById(id)) return

  const style = document.createElement('style')

  style.id = id
  style.textContent = `
    @keyframes snowfallAnimation {
      0% {
        transform: 
          translateY(-10px) 
          translateX(var(--start-x, 0px)) 
          rotate(var(--start-rot, 0deg));
        opacity: 0;
      }
      10% {
        opacity: 1;
      }
      90% {
        opacity: 1;
      }
      100% {
        transform: 
          translateY(100vh) 
          translateX(var(--end-x, -10vw)) 
          rotate(var(--end-rot, 720deg));
        opacity: 0;
      }
    }
  `
  document.head.appendChild(style)
}

const Snowflake = ({
  left,
  size,
  duration,
  delay,
  rotationStart,
  rotationEnd,
  startX,
  endX,
}: {
  left: number
  size: number
  duration: number
  delay: number
  rotationStart: number
  rotationEnd: number
  startX: number // в px или vw, например: 0
  endX: number // например: -30 (в vw)
}) => (
  <div
    style={
      {
        position: 'absolute',
        top: '-20px',
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        background: `url('https://static.vecteezy.com/system/resources/previews/016/713/774/non_2x/openwork-blue-snowflake-illustration-with-transparent-background-free-png.png') no-repeat`,
        backgroundSize: 'contain',
        // --- CSS Variables for animation ---
        '--start-x': `${startX}px`,
        '--end-x': `${endX}vw`,
        '--start-rot': `${rotationStart}deg`,
        '--end-rot': `${rotationEnd}deg`,
        animation: `snowfallAnimation ${duration}s ${delay}s linear infinite`,
        pointerEvents: 'none',
      } as React.CSSProperties
    } // нужно для кастомных CSS-переменных
  />
)

const Snowfall = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    injectKeyframes() // ✅ Вставляем анимацию
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  const snowflakes = Array.from({ length: 50 }, (_, i) => {
    const left = Math.random() * 100
    const size = Math.random() * 10 + 4
    const duration = Math.random() * 7 + 8 // 8–15 сек
    const delay = Math.random() * 5

    // Начальный и конечный поворот
    const rotationStart = Math.random() * 360
    const rotationEnd = rotationStart + Math.random() * 720 + 360 // от +360 до +1080

    // Горизонтальное смещение: сделаем "наклон" влево или вправо
    // startX — небольшой джиттер в начале (макс ±2px)
    const startX = (Math.random() - 0.5) * 4 // от -2 до +2 px
    // endX — смещение за пределы экрана: от -30vw до +20vw (асимметрично, чтобы "ветер слева")
    const endX = Math.random() * 50 - 30 // от -30 до +20 vw — косой дождь/снег!

    return {
      id: i,
      left,
      size,
      duration,
      delay,
      rotationStart,
      rotationEnd,
      startX,
      endX,
    }
  })

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      {snowflakes.map((sf) => (
        <Snowflake key={sf.id} {...sf} />
      ))}
    </div>
  )
}

export default Snowfall
